<script setup>
import { provide, watch, computed, inject, ref } from 'vue';
import * as yup from 'yup';
import { useForm } from 'vee-validate';
import { 
	__, 
	updateURL, 
	setFormValues, 
	handleLeadQuery,
	getFormValuesFromLocalStorage
} from '@/utils';

const { setActiveStep, 
	nextStep, 
	activeStep, 
	setValidStep,
} = inject('step');
const form = ref('');

const jsonValues = getFormValuesFromLocalStorage();

const validationSchema = [
	null,
	yup.object().shape({
		roamingCustomerNumber: yup.string().required(__('Required field')).min(11, __('Required field')),
	}),
	null
];

const currentSchema = computed(() => {
	return validationSchema[activeStep.value - 1];
});

const { values, handleSubmit, defineField, resetForm, validate, meta } = useForm({
	validationSchema: currentSchema,
	keepValuesOnUnmount: true,
	initialValues: jsonValues ? jsonValues : {
		departureDate: "",
		roamingCustomerNumber: ""
	}
});

handleLeadQuery();

const onSubmit = handleSubmit((values) => {
	setValidStep(true);
	updateURL(`#step${nextStep()}`)

	setActiveStep(nextStep());
}, (errors) => {
	setValidStep(false);
});


watch(values, (newValues) => {
	setFormValues(newValues);
});

provide('form', { defineField, resetForm, validate, form, values, meta });
</script>

<template>
	<div class="section-steps">
		<div class="section__shell">
			<div class="section__container">
				<div class="section__content">
					<form ref="form" class="form-steps form-steps-roaming" @submit="onSubmit" @keydown.enter="$event.preventDefault()">
						<slot />
					</form>
				</div><!-- /.section__content -->

				<div class="section__image section__image-roaming">
				</div><!-- /.section__image -->
			</div><!-- /.section__container -->
		</div><!-- /.section__shell -->
	</div><!-- /.section-steps -->
</template>
